import { generatePayloadBase, sendPixelEvent, eventFactory } from "@polar-analytics/pixel-sdk";
import { SHOPIFY_DOMAIN, CURRENCY, SITE_URL } from "utils/constants";
import * as CookieConsent from "vanilla-cookieconsent";

const POLAR_ENDPOINT = "https://api-production.polaranalytics.com/pixel";

const hasConsent = () => CookieConsent.acceptedCategory("analytics_storage");

const send = async (event) => {
	if (!hasConsent()) return;
	try {
		const payloadBase = await generatePayloadBase({});
		await sendPixelEvent(POLAR_ENDPOINT, payloadBase, { data: event });
	} catch {
		// never break existing analytics
	}
};

export const polarTrackPageView = () =>
	send(
		eventFactory.page_viewed({
			shopifyEventId: crypto.randomUUID(),
			shopifyShopURL: SHOPIFY_DOMAIN,
		}),
	);

export const polarTrackProductView = (product) =>
	send(
		eventFactory.product_viewed({
			shopifyEventId: crypto.randomUUID(),
			shopifyShopURL: SHOPIFY_DOMAIN,
			shopifyPageType: "product",
			shopifyPageDetail: product?.handle || product?.title || "",
			shopifyPageProductId: product?.id || null,
			shopifyEventData: {
				productVariant: {
					id: product?.variant?.id || null,
					image: product?.image ? { src: product.image } : null,
					price: {
						amount: parseFloat(product?.variant?.price) || 0,
						currencyCode: CURRENCY,
					},
					product: {
						id: product?.id || null,
						title: product?.title || product?.shopifyTitle || "",
						type: product?.type || null,
						untranslatedTitle: product?.title || product?.shopifyTitle || null,
						url: product?.handle ? `${SITE_URL}/products/${product.handle}` : null,
						vendor: "Every",
					},
					sku: product?.variant?.sku || null,
					title: product?.variant?.title || null,
					untranslatedTitle: product?.variant?.title || null,
				},
			},
		}),
	);

export const polarTrackAddToCart = (products) => {
	[].concat(products).forEach((product) =>
		send(
			eventFactory.product_added_to_cart({
				shopifyEventId: crypto.randomUUID(),
				shopifyShopURL: SHOPIFY_DOMAIN,
				shopifyEventData: {
					cartLine: {
						cost: {
							totalAmount: {
								amount:
									parseFloat(product?.variant?.price || product?.basePrice || product?.price || 0) *
									(product?.quantity || 1),
								currencyCode: CURRENCY,
							},
						},
						merchandise: {
							id: product?.variant?.id || null,
							image: product?.image ? { src: product.image } : null,
							price: {
								amount: parseFloat(product?.variant?.price || product?.basePrice || product?.price || 0),
								currencyCode: CURRENCY,
							},
							product: {
								id: product?.id || null,
								title: product?.title || product?.shopifyTitle || product?.productTitle || "",
								type: product?.type || null,
								untranslatedTitle: product?.title || product?.shopifyTitle || null,
								url: product?.handle ? `${SITE_URL}/products/${product.handle}` : null,
								vendor: "Every",
							},
							sku: product?.variant?.sku || product?.sku || null,
							title: product?.variant?.title || product?.variantTitle || null,
							untranslatedTitle: product?.variant?.title || product?.variantTitle || null,
						},
						quantity: product?.quantity || 1,
					},
				},
			}),
		),
	);
};
